import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { leadSettingsApi } from '../api/leadSettingsApi';
import { LeadSettingsDto } from '../types/leadSettings';

const OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 60 * 1000,
} as const;

export const useLeadSettings = () =>
  useQuery({
    queryKey: ['lead-settings'],
    queryFn: () => leadSettingsApi.getSettings(),
    ...OPTIONS,
  });

export const useSaveLeadSettings = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data: LeadSettingsDto) => leadSettingsApi.saveSettings(data),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['lead-settings'] });
      toast.success('Lead settings saved');
    },
    onError: () => {
      toast.error('Failed to save lead settings');
    },
  });
};

export const usePublicLeadSettings = (slug: string | undefined) =>
  useQuery({
    queryKey: ['public-lead-settings', slug],
    queryFn: () => leadSettingsApi.getPublicSettings(slug as string),
    enabled: Boolean(slug),
    ...OPTIONS,
  });

export const usePublicNewsletterSettings = (slug: string | undefined) =>
  useQuery({
    queryKey: ['public-lead-settings', slug],
    queryFn: () => leadSettingsApi.getPublicNewsletterSettings(slug as string),
    enabled: Boolean(slug),
    ...OPTIONS,
  });
